import { useRef, useState } from 'react';
import classnames from 'classnames';
import { useOutsideClick } from '@/hooks/useOutsideClick';
import { ReportFaqButton } from '@/components/TaxReport/ReportFaqButton';
import { ExportButton } from '@/components/TaxReport/ExportButton';
import Icon from './icon_dots.svg';
import s from './index.module.scss';

export const ActionMenu = () => {
  const ref = useRef();
  const [open, setOpen] = useState(false);

  useOutsideClick(ref, () => setOpen(false), open);

  return (
    <div ref={ref} className={s.wrapper}>
      <button type="button" onClick={() => setOpen(!open)} className={s.burger}>
        <img src={Icon} alt="dots" width={20} height={20} />
      </button>
      {open && (
        <div className={s.menu}>
          <ExportButton className={s.item} />
          <ReportFaqButton className={classnames(s.item, s.report)} />
        </div>
      )}
    </div>
  );
};
